const actions = {
  POST_LOGIN_BEGIN: 'POST_LOGIN_BEGIN',
  POST_LOGIN_SUCCESS: 'POST_LOGIN_SUCCESS',
  POST_LOGIN_FAILED: 'POST_LOGIN_FAILED',

  LOGOUT_USER: 'LOGOUT_USER',

  GET_CAR_AMIGOS_BEGIN: 'GET_CAR_AMIGOS_BEGIN',
  GET_CAR_AMIGOS_SUCCESS: 'GET_CAR_AMIGOS_SUCCESS',
  GET_CAR_AMIGOS_FAILED: 'GET_CAR_AMIGOS_FAILED',

  GET_CAR_AMIGOS_DETAIL_BEGIN: 'GET_CAR_AMIGOS_DETAIL_BEGIN',
  GET_CAR_AMIGOS_DETAIL_SUCCESS: 'GET_CAR_AMIGOS_DETAIL_SUCCESS',
  GET_CAR_AMIGOS_DETAIL_FAILED: 'GET_CAR_AMIGOS_DETAIL_FAILED',

  REQUEST_CAR_BEGIN: 'REQUEST_CAR_BEGIN',
  REQUEST_CAR_SUCCESS: 'REQUEST_CAR_SUCCESS',
  REQUEST_CAR_FAILED: 'REQUEST_CAR_FAILED',

  GET_IMPORTED_CARS_BEGIN: 'GET_IMPORTED_CARS_BEGIN',
  GET_IMPORTED_CARS_SUCCESS: 'GET_IMPORTED_CARS_SUCCESS',
  GET_IMPORTED_CARS_FAILED: 'GET_IMPORTED_CARS_FAILED',

  GET_IMPORTED_CAR_IDS_BEGIN: 'GET_IMPORTED_CAR_IDS_BEGIN',
  GET_IMPORTED_CAR_IDS_SUCCESS: 'GET_IMPORTED_CAR_IDS_SUCCESS',
  GET_IMPORTED_CAR_IDS_FAILED: 'GET_IMPORTED_CAR_IDS_FAILED',

  DELETE_IMPORTED_CAR_BEGIN: 'DELETE_IMPORTED_CAR_BEGIN',
  DELETE_IMPORTED_CAR_SUCCESS: 'DELETE_IMPORTED_CAR_SUCCESS',
  DELETE_IMPORTED_CAR_FAILED: 'DELETE_IMPORTED_CAR_FAILED',

  POST_CAR_IMPORT_BEGIN: 'POST_CAR_IMPORT_BEGIN',
  POST_CAR_IMPORT_SUCCESS: 'POST_CAR_IMPORT_SUCCESS',
  POST_CAR_IMPORT_FAILED: 'POST_CAR_IMPORT_FAILED',

  GET_REQUESTED_CAR_BEGIN: 'GET_REQUESTED_CAR_BEGIN',
  GET_REQUESTED_CAR_SUCCESS: 'GET_REQUESTED_CAR_SUCCESS',
  GET_REQUESTED_CAR_FAILED: 'GET_REQUESTED_CAR_FAILED',

  RE_REQUEST_CAR_BEGIN: 'RE_REQUEST_CAR_BEGIN',
  RE_REQUEST_CAR_SUCCESS: 'RE_REQUEST_CAR_SUCCESS',
  RE_REQUEST_CAR_FAILED: 'RE_REQUEST_CAR_FAILED',

  PUT_CAR_INSPECTION_BEGIN: 'PUT_CAR_INSPECTION_BEGIN',
  PUT_CAR_INSPECTION_SUCCESS: 'PUT_CAR_INSPECTION_SUCCESS',
  PUT_CAR_INSPECTION_FAILED: 'PUT_CAR_INSPECTION_FAILED',

  PUT_PURCHASE_ORDER_BEGIN: 'PUT_PURCHASE_ORDER_BEGIN',
  PUT_PURCHASE_ORDER_SUCCESS: 'PUT_PURCHASE_ORDER_SUCCESS',
  PUT_PURCHASE_ORDER_FAILED: 'PUT_PURCHASE_ORDER_FAILED',

  PUT_START_PAYMENT_BEGIN: 'PUT_START_PAYMENT_BEGIN',
  PUT_START_PAYMENT_SUCCESS: 'PUT_START_PAYMENT_SUCCESS',
  PUT_START_PAYMENT_FAILED: 'PUT_START_PAYMENT_FAILED',

  IMPORTED_CAR_REORDER_BEGIN: 'IMPORTED_CAR_REORDER_BEGIN',
  IMPORTED_CAR_REORDER_SUCCESS: 'IMPORTED_CAR_REORDER_SUCCESS',
  IMPORTED_CAR_REORDER_FAILED: 'IMPORTED_CAR_REORDER_FAILED',

  SET_IMPORTED_CARS: 'SET_IMPORTED_CARS',
  SET_ALL_IMPORTED_CAR_IDS: 'SET_ALL_IMPORTED_CAR_IDS',

  RE_FETCH_IMPORTED_CAR_BEGIN: 'RE_FETCH_IMPORTED_CAR_BEGIN',
  RE_FETCH_IMPORTED_CAR_SUCCESS: 'RE_FETCH_IMPORTED_CAR_SUCCESS',
  RE_FETCH_IMPORTED_CAR_FAILED: 'RE_FETCH_IMPORTED_CAR_FAILED',

  postLoginBegin: () => {
    return {
      type: actions.POST_LOGIN_BEGIN,
    };
  },

  postLoginSuccess: data => {
    return {
      type: actions.POST_LOGIN_SUCCESS,
      data,
    };
  },

  postLoginFailed: err => {
    return {
      type: actions.POST_LOGIN_FAILED,
      err,
    };
  },

  logoutUser: () => {
    return {
      type: actions.LOGOUT_USER,
    };
  },

  getCarAmigoBegin: () => {
    return {
      type: actions.GET_CAR_AMIGOS_BEGIN,
    };
  },

  getCarAmigoSuccess: data => {
    return {
      type: actions.GET_CAR_AMIGOS_SUCCESS,
      data,
    };
  },

  getCarAmigoFailed: err => {
    return {
      type: actions.GET_CAR_AMIGOS_FAILED,
      err,
    };
  },

  getCarAmigoDetailBegin: () => {
    return {
      type: actions.GET_CAR_AMIGOS_DETAIL_BEGIN,
    };
  },

  getCarAmigoDetailSuccess: data => {
    return {
      type: actions.GET_CAR_AMIGOS_DETAIL_SUCCESS,
      data,
    };
  },

  getCarAmigoDetailFailed: err => {
    return {
      type: actions.GET_CAR_AMIGOS_DETAIL_FAILED,
      err,
    };
  },

  requestCarAmigoBegin: () => {
    return {
      type: actions.REQUEST_CAR_BEGIN,
    };
  },

  requestCarAmigoSuccess: data => {
    return {
      type: actions.REQUEST_CAR_SUCCESS,
      data,
    };
  },

  requestCarAmigoFailed: err => {
    return {
      type: actions.REQUEST_CAR_FAILED,
      err,
    };
  },

  reRequestCarBegin: data => {
    return {
      type: actions.RE_REQUEST_CAR_BEGIN,
      data,
    };
  },

  reRequestCarSuccess: () => {
    return {
      type: actions.RE_REQUEST_CAR_SUCCESS,
    };
  },

  reRequestCarFailed: err => {
    return {
      type: actions.RE_REQUEST_CAR_FAILED,
      err,
    };
  },

  getRequestedCarsBegin: () => {
    return {
      type: actions.GET_REQUESTED_CAR_BEGIN,
    };
  },

  getRequestedCarsSuccess: data => {
    return {
      type: actions.GET_REQUESTED_CAR_SUCCESS,
      data,
    };
  },

  getRequestedCarsFailed: err => {
    return {
      type: actions.GET_REQUESTED_CAR_FAILED,
      err,
    };
  },

  getAlreadyImportedCarsBegin: () => {
    return {
      type: actions.GET_IMPORTED_CARS_BEGIN,
    };
  },

  getAlreadyImportedCarsSuccess: data => {
    return {
      type: actions.GET_IMPORTED_CARS_SUCCESS,
      data,
    };
  },

  getAlreadyImportedCarsFailed: err => {
    return {
      type: actions.GET_IMPORTED_CARS_FAILED,
      err,
    };
  },

  getImportedCarIdsBegin: () => {
    return {
      type: actions.GET_IMPORTED_CAR_IDS_BEGIN,
    };
  },

  getImportedCarIdsSuccess: data => {
    return {
      type: actions.GET_IMPORTED_CAR_IDS_SUCCESS,
      data,
    };
  },

  getImportedCarIdsFailed: err => {
    return {
      type: actions.GET_IMPORTED_CAR_IDS_FAILED,
      err,
    };
  },

  deleteImportedCarBegin: () => {
    return {
      type: actions.DELETE_IMPORTED_CAR_BEGIN,
    };
  },

  deleteImportedCarSuccess: () => {
    return {
      type: actions.DELETE_IMPORTED_CAR_SUCCESS,
    };
  },

  deleteImportedCarFailed: () => {
    return {
      type: actions.DELETE_IMPORTED_CAR_FAILED,
    };
  },

  postCarImportBegin: () => {
    return {
      type: actions.POST_CAR_IMPORT_BEGIN,
    };
  },

  postCarImportSuccess: data => {
    return {
      type: actions.POST_CAR_IMPORT_SUCCESS,
      data,
    };
  },

  postCarImportFailed: err => {
    return {
      type: actions.POST_CAR_IMPORT_FAILED,
      err,
    };
  },
  putCarInspectionBegin: data => {
    return {
      type: actions.PUT_CAR_INSPECTION_BEGIN,
      data,
    };
  },

  putCarInspectionSuccess: () => {
    return {
      type: actions.PUT_CAR_INSPECTION_SUCCESS,
    };
  },

  putCarInspectionFailed: err => {
    return {
      type: actions.PUT_CAR_INSPECTION_FAILED,
      err,
    };
  },

  putPurchaseOrderBegin: data => {
    return {
      type: actions.PUT_PURCHASE_ORDER_BEGIN,
      data,
    };
  },

  putPurchaseOrderSuccess: () => {
    return {
      type: actions.PUT_PURCHASE_ORDER_SUCCESS,
    };
  },

  putPurchaseOrderFailed: err => {
    return {
      type: actions.PUT_PURCHASE_ORDER_FAILED,
      err,
    };
  },

  putPaymentOrderBegin: data => {
    return {
      type: actions.PUT_START_PAYMENT_BEGIN,
      data,
    };
  },

  putPaymentOrderSuccess: () => {
    return {
      type: actions.PUT_START_PAYMENT_SUCCESS,
    };
  },

  putPaymentOrderFailed: err => {
    return {
      type: actions.PUT_START_PAYMENT_FAILED,
      err,
    };
  },

  reOrderImportedCarBegin: data => {
    return {
      type: actions.IMPORTED_CAR_REORDER_BEGIN,
      data,
    };
  },

  reOrderImportedSuccess: () => {
    return {
      type: actions.IMPORTED_CAR_REORDER_SUCCESS,
    };
  },

  reOrderImportedFailed: err => {
    return {
      type: actions.IMPORTED_CAR_REORDER_FAILED,
      err,
    };
  },

  setImportedCars: data => {
    return {
      type: actions.SET_IMPORTED_CARS,
      data,
    };
  },

  setAllImportedCarIds: data => {
    return {
      type: actions.SET_ALL_IMPORTED_CAR_IDS,
      data,
    };
  },

  reFetchImportedCarBegin: () => {
    return {
      type: actions.RE_FETCH_IMPORTED_CAR_BEGIN,
    };
  },

  reFetchImportedCarSuccess: () => {
    return {
      type: actions.RE_FETCH_IMPORTED_CAR_SUCCESS,
    };
  },

  reFetchImportedCarFailed: err => {
    return {
      type: actions.RE_FETCH_IMPORTED_CAR_FAILED,
      err,
    };
  },
};

export default actions;
